import { render, staticRenderFns } from "./SiteNotificationPropertiesView.vue?vue&type=template&id=d75c80a2&scoped=true&"
import script from "./SiteNotificationPropertiesView.vue?vue&type=script&lang=js&"
export * from "./SiteNotificationPropertiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75c80a2",
  null
  
)

export default component.exports